import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowDiagonalIn = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 2.5L10 10L9.69716 9.69715", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M14 3L21 3.00001L21 21L3 21L3 14", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 10L10 10L10 3", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowDiagonalIn.js.map